import React from "react";
import { Grid, Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Channels from "./Channels";
import MessageSection from "./MessageSection";
import PendingConversation from "./MessageSection/PendingConversation";
import ApproveConversation from "./MessageSection/ApproveConversation";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(theme => ({
  messagingContainer: {
    flex: 1,
    height: "100%",
  },
  messageSection: {
    display: "flex",
    flexGrow: 1,
  },
  channelsSection: {
    height: "100%",
  },
}));

const DesktopView = ({
  activeChannelId,
  activeConversationId,
  channel,
  channelLoading,
  channels,
  channelsLoading,
  conversation,
  conversationLoading,
  conversations,
  conversationsLoading,
  onChannelSelected,
  onConversationAdded,
  onConversationSelected,
  setSiteId,
  onPendingConversationSelected,
  activePendingConversation
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={0} className={classes.messagingContainer}>
      <Grid item xs={12} md={2} className={classes.channelsSection}>
        <Channels
          activeChannelId={activeChannelId}
          activeConversationId={activeConversationId}
          channels={channels}
          channelsLoading={channelsLoading}
          conversations={conversations}
          conversationsLoading={conversationsLoading}
          onChannelSelected={onChannelSelected}
          onConversationAdded={onConversationAdded}
          onConversationSelected={onConversationSelected}
          setSiteId={setSiteId}
          onPendingConversationSelected={onPendingConversationSelected}
        />
      </Grid>
      <Grid item xs={12} md={10} className={classes.messageSection}>

        {activePendingConversation ? (
          <PendingConversation
            activePendingConversation={activePendingConversation}
            onConversationAdded={onConversationAdded}
          />
        ) : conversation && !conversation.isApproved ? (
          conversation.hasCurrentUserApproved ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                position: "relative",
                height: "100%",
                pb: 2,
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  px: 3,
                  py: 2,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  bgcolor: "background.paper",
                }}
              >
                <Typography>
                  <FormattedMessage id="messaging.waitingForOtherUser" />
                </Typography>
              </Paper>
            </Box>
          ) : (
              <ApproveConversation conversation={conversation} />
            )
        ) : (
              <MessageSection
                activeChannelId={activeChannelId}
                activeConversationId={activeConversationId}
                channel={channel}
                channelLoading={channelLoading}
                conversation={conversation}
                conversationLoading={conversationLoading}
              />
            )}
      </Grid>
    </Grid>
  );
};

export default DesktopView;
